import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isVerifying, setIsVerifying] = useState(true);

  useEffect(() => {
    const handleAuthCallback = async () => {
      try {
        // Supabase automatically handles the token from URL
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) throw error;
        
        if (session) {
          toast({
            title: "Welcome! 🎉",
            description: "You're signed in successfully",
          });
          
          const onboardingComplete = localStorage.getItem('onboardingComplete');
          navigate(onboardingComplete ? '/' : '/onboarding');
        } else {
          throw new Error('No session found');
        }
      } catch (error: any) {
        console.error('Auth callback error:', error);
        toast({
          title: "Authentication failed",
          description: "The link may have expired. Please try again.",
          variant: "destructive",
        });
        navigate('/auth');
      } finally {
        setIsVerifying(false);
      }
    };

    handleAuthCallback();
  }, [navigate, toast]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-primary/10 via-background to-success/10 p-4">
      <div className="text-center space-y-4">
        {isVerifying ? (
          <>
            <Loader2 className="w-16 h-16 text-primary animate-spin mx-auto" />
            <p className="text-lg text-muted-foreground">Verifying your magic link...</p>
          </>
        ) : (
          <p className="text-lg text-muted-foreground">Redirecting...</p>
        )}
      </div>
    </div>
  );
}
